import { API_AUTH } from "./common";

const DuNoNhanVayApi = {
  list: ({ dateFrom, dateTo, tenChuNo, nhanvien }) =>
    API_AUTH.get(
      `bao-cao/du-no-nhan-vay?dateFrom=${dateFrom}&dateTo=${dateTo}&tenChuNo=${tenChuNo}&nhanvien=${nhanvien}`,
      {}
    ),
  list1: ({
    dateFrom,
    dateTo,
    tenChuNo,
    nhanvien,
    mataisan,
    trangthai,
    sotienvay,
  }) =>
    API_AUTH.get(
      `bao-cao/du-no-nhan-vay-1?dateFrom=${dateFrom}&dateTo=${dateTo}&tenChuNo=${tenChuNo}&nhanvien=${nhanvien}&mataisan=${mataisan}&trangthai=${trangthai}&sotienvay=${sotienvay}`,
      {}
    ),
  getListChiTietDuNo: (dateFrom, dateTo, tenChuNo, nhanvien) =>
    API_AUTH.get(
      `bao-cao/chi-tiet-du-no-nhan-vay?dateFrom=${dateFrom}&dateTo=${dateTo}&tenChuNo=${tenChuNo}&nhanvien=${nhanvien}`,
      {}
    ),

    getListChiTietDuNo1: (dateFrom,
      dateTo,
      tenChuNo,
      nhanvien,
      mataisan,
      trangthai,
      sotienvay) =>
    API_AUTH.get(
      `bao-cao/chi-tiet-du-no-nhan-vay1?dateFrom=${dateFrom}&dateTo=${dateTo}&tenChuNo=${tenChuNo}&nhanvien=${nhanvien}&mataisan=${mataisan}&trangthai=${trangthai}&sotienvay=${sotienvay}`,
      {}
    ), 
};

export default DuNoNhanVayApi;
